import React, {useEffect, useState} from 'react';

import Loader from '../../../../common/component/Loader/Loader';

import {useToast} from '../../../../common/hook/toast';

import {useHttpClient} from '../../../../common/hook/http';
import currency from '../../../../common/util/currency';
import useCopyToClipboard from "../../../../common/hook/copy-to-clipboard";

import GlobalConst from '../../../../common/global-const';

import {Row, Col, Card, Button} from 'react-bootstrap';

import {ReactComponent as ImgMicaCoin} from '../../../../asset/img/icon/mica-coin.svg';
import {ReactComponent as ImgMicaCredit} from '../../../../asset/img/icon/mica-credit.svg';
import {ReactComponent as ImgMicaTicket} from '../../../../asset/img/icon/mica-ticket.svg';
import * as IconFi from 'react-icons/fi';

import './CustomerClub.scss'

const AccountCustomerClub = () => {
    const {callAPI} = useHttpClient()
    const {callToast} = useToast()
    const [copyToClipboard] = useCopyToClipboard()

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [data, setData] = useState(null)

    useEffect(() => {

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    `customer`
                );

                if (responseData.message) {
                    callToast('secondary', null, null, responseData.message);
                } else {

                    setData(responseData.result)

                }

            } catch (e) {
                console.error(e);
            }
        }

        fetchData()

    }, []);

    // -----------------------------------------------------------------------------------------------------------------

    const [btnText, setBtnText] = useState(<><IconFi.FiCopy size={24} className="sw-1 me-2"/>کپی کن</>)

    const copyToClipboardHandler = async code => {

        const copied = await copyToClipboard(`https://www.micamall.com/referral?code=${code}`)

        if (copied) {

            setBtnText(<><IconFi.FiCheck size={24} className="sw-1 me-2"/>کپی شد</>)

            let timeout = setTimeout(() => {

                clearTimeout(timeout)

                setBtnText(<><IconFi.FiCopy size={24} className="sw-1 me-2"/>کپی کن</>)

            }, 2000)

        }

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <div id="pageAccountMicaCoin">
                {
                    data ? (
                        <>
                            <Row className="g-0">
                                <Col xs={12}>
                                    {
                                        data?.bankCards?.length ? (
                                            <>جهت مشاهده جزئیات تراکنش ها از بخش های Mica Coin و Mica Credit و Mica Cash بازدید نمایید.</>
                                        ) : (
                                            <>
                                                <div>کاربر گرامی، در حال حاضر افزودن کوین، اعتبار خرید مجدد و یا اعتبار نقدی به حساب شما امکان پذیر نمی باشد.</div>
                                                <div>شماره کارت های بانکی که جهت خرید استفاده می نمایید را در بخش شماره کارت بانک ثبت نمایید.</div>
                                            </>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row className="g-0">
                                <Col sm={12}>
                                    <div className="fs-5 pb-3 mt-2">کد معرف <span className="ls-1 ps-1">{data.customer?.id}</span>
                                        <Button variant="link" className="ms-2 text-decoration-none" onClick={() => copyToClipboardHandler(data.customer?.id)}>{btnText}</Button>
                                    </div>
                                </Col>
                                <Col sm={6} className="bg-elevate-2">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-3 pt-sm-4 pb-0 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">رتبه فعلی {data.customer.rankStatus === '-1' ? <span className="text-danger fs-6">(<IconFi.FiArrowDown size={18} className="sw-1 me-1"/>کاهش)</span> : <span className="text-success fs-6">(<IconFi.FiArrowUp size={18} className="sw-1 me-1"/>افزایش)</span>}</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base" style={{color: data.customer.currentRank?.color}}>{data.customer.currentRank?.title || <>&nbsp;</>}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pb-3 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">رتبه قبلی</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base" style={{color: data.customer.previousRank?.color}}>{data.customer.previousRank?.title || <>&nbsp;</>}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} className="bg-elevate-16">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-3 pt-sm-4 pb-0 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تاریخ تغییر رتبه</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.rankStatus === '-1' ? data.customer.rankDemotionDateShamsi : data.customer.rankPromotionDateShamsi ? data.customer.rankPromotionDateShamsi : <>&nbsp;</>}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pb-3 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تاریخ محاسبه رتبه</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.rankEvaluationDateShamsi || <>&nbsp;</>}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={12}>
                                    <h2 className="fw-normal fs-4 my-4 d-flex align-items-center"><ImgMicaCoin className="sw-1 me-3"/>موجودی کوین {data.customer.availablePoint}</h2>
                                </Col>
                                <Col sm={6} className="bg-accent text-primary">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-3 pb-0 pt-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">کوین دریافت شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.totalBuyPoint}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pb-0 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">کوین هدیه</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.totalGiftPoint}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} className="bg-accent text-primary">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pt-sm-4 pb-0 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">کوین مصرف شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.totalUsedPoint}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pb-sm-3 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">کوین منقضی شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.totalExpiredPoint}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={12}>
                                    <h2 className="fw-normal fs-4 my-4 d-flex align-items-center"><ImgMicaCredit className="sw-1 me-3"/>موجودی اعتبار خرید مجدد {currency(data.customer.availableCredit)} {GlobalConst.currency}</h2>
                                </Col>
                                <Col sm={6} className="bg-primary text-accent">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-3 pt-sm-4 pb-0 pt-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">اعتبار خرید مجدد دریافت شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalEarnedCredit)} {GlobalConst.currency}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pb-0 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">اعتبار خرید مجدد مصرف شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalUsedCredit)} {GlobalConst.currency}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} className="bg-primary text-accent">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pt-sm-4 pb-3 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تاریخ محاسبه اعتبار خرید مجدد</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.creditEvaluationDateShamsi}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={12}>
                                    <h2 className="fw-normal fs-4 my-4 d-flex align-items-center"><ImgMicaTicket className="sw-1 me-3"/>موجودی اعتبار نقدی {currency(data.customer.availableTicket)} {GlobalConst.currency}</h2>
                                </Col>
                                <Col sm={6} className="bg-accent-2 text-primary">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-3 pt-sm-4 pb-0 pt-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">اعتبار نقدی دریافت شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalEarnedTicket)} {GlobalConst.currency}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pb-0 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">اعتبار نقدی مصرف شده</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalUsedTicket)} {GlobalConst.currency}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} className="bg-accent-2 text-primary">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-0 pt-sm-4 pb-3 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تاریخ محاسبه اعتبار نقدی</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.ticketEvaluationDateShamsi}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} className="bg-accent-3 text-secondary">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pt-3 pb-0 pt-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تاریخ اولین خرید</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.firstBuyDateShamsi || <>&nbsp;</>}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="py-0 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تاریخ آخرین خرید</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.lastBuyDateShamsi || <>&nbsp;</>}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={6} className="bg-accent-3 text-secondary">
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="py-0 pt-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">مبلغ خرید</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalBuyPrice)} <span className="fs-4">{GlobalConst.currency}</span></Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                    <Card className="border-0 rounded-0 bg-transparent">
                                        <Card.Body className="pb-3 pt-0 pb-sm-4 px-4">
                                            <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">تعداد خرید</Card.Title>
                                            <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{data.customer.numberOfBuy}</Card.Subtitle>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <div className="py-5 my-5">
                            <Loader text="در حال دریافت اطلاعات"/>
                        </div>
                    )
                }
            </div>
        </>
    )
}

export default AccountCustomerClub;